module.exports = __webpack_public_path__ + "img/02_03.54b6f221.png";